<template>
    <div>
        <b-collapse id="settings-collapse" v-model="showSettings">
            <div class="card">
                <div class="card-header">
                    <h5 class="mb-0">기본 등록 정보 설정</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <!-- 왼쪽 컬럼: 기본 등록 정보 -->
                        <div class="col-md-6">
                            <div class="card mb-3">
                                <div class="card-header bg-light">
                                    <h6 class="mb-0">기본 등록 정보</h6>
                                </div>
                                <div class="card-body">
                                    <b-form-group label="브랜드명" label-for="brand-input">
                                        <b-form-input id="brand-input" v-model="settingsData.brand"
                                            placeholder="브랜드명을 입력해주세요 (','로 구분하여 여러 브랜드 입력 가능)" trim></b-form-input>
                                        <small class="form-text text-muted">
                                            쉼표(,)로 구분하여 여러 브랜드를 입력할 수 있습니다. (예: 나이키,아디다스,푸마)
                                        </small>
                                    </b-form-group>

                                    <b-form-group label="제조사" label-for="manufacturer-input">
                                        <b-form-input id="manufacturer-input" v-model="settingsData.manufacturer"
                                            placeholder="제조사를 입력해주세요" trim></b-form-input>
                                    </b-form-group>

                                    <b-form-group label="수입 및 판매원" label-for="importer-input">
                                        <b-form-input id="importer-input" v-model="settingsData.importer"
                                            placeholder="수입 및 판매원을 입력해주세요" trim></b-form-input>
                                    </b-form-group>

                                    <b-form-group label="거래타입" label-for="transaction-type-select">
                                        <b-form-select id="transaction-type-select"
                                            v-model="settingsData.transactionType"
                                            :options="transactionTypeOptions"></b-form-select>
                                    </b-form-group>

                                    <b-form-group label="수입여부" label-for="import-status-select">
                                        <b-form-select id="import-status-select" v-model="settingsData.importStatus"
                                            :options="importStatusOptions"></b-form-select>
                                    </b-form-group>

                                    <b-form-group label="A/S 책임자와 전화번호" label-for="as-info-input">
                                        <b-form-input id="as-info-input" v-model="settingsData.asInfo"
                                            placeholder="예: 홍길동 / 010-1234-5678" trim></b-form-input>
                                    </b-form-group>

                                    <b-form-group label="박스 내 SKU 수량" label-for="total-skus-in-box">
                                        <b-form-input
                                            id="total-skus-in-box"
                                            v-model.number="settingsData.totalSKUsInBox"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            placeholder="1개의 박스에 담긴 SKU 수량">
                                        </b-form-input>
                                        <small class="form-text text-muted">
                                            1개의 박스에 담긴 SKU 수량을 입력해주세요. 기본값은 1입니다.
                                        </small>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>

                        <!-- 오른쪽 컬럼: 가격설정 방법 -->
                        <div class="col-md-6">
                            <div class="card mb-3">
                                <div class="card-header bg-light">
                                    <h6 class="mb-0">가격설정 방법</h6>
                                </div>
                                <div class="card-body">
                                    <!-- 비율 시각화 -->
                                    <div class="row mb-2 mt-2">
                                        <div class="col-md-4 text-center">상품 원가</div>
                                        <div class="col-md-4 text-center">공급 마진</div>
                                        <div class="col-md-4 text-center">쿠팡 마진</div>
                                    </div>
                                    <div class="progress mb-3" style="height: 30px; border-radius: 5px;">
                                        <div class="progress-bar bg-warning" role="progressbar"
                                            :style="{ width: costRatio + '%' }" :aria-valuenow="costRatio"
                                            aria-valuemin="0" aria-valuemax="100">
                                            {{ costRatio.toFixed(0) }}%
                                        </div>
                                        <div class="progress-bar bg-success" role="progressbar"
                                            :style="{ width: marginRatioPercent + '%' }"
                                            :aria-valuenow="marginRatioPercent" aria-valuemin="0" aria-valuemax="100">
                                            {{ marginRatioPercent ? marginRatioPercent.toFixed(0) : 40 }}%
                                        </div>
                                        <div class="progress-bar bg-primary" role="progressbar"
                                            :style="{ width: coupangRatioPercent + '%' }"
                                            :aria-valuenow="coupangRatioPercent" aria-valuemin="0" aria-valuemax="100">
                                            {{ coupangRatioPercent ? coupangRatioPercent.toFixed(0) : 40 }}%
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-around">
                                        <!-- 환율 및 반올림 단위 -->
                                        <div class="d-flex flex-column align-items-center text-center">
                                            <b-form-group label="쿠패스 통합통관 환율"
                                                description="켜면 매입가 = (위안가 × 통합통관환율 + 포장검수 200원 + 바코드 100원) × 1.1">
                                                <b-form-checkbox v-model="settingsData.useIntegratedRate" switch
                                                    @change="onIntegratedRateToggle">
                                                    {{ settingsData.useIntegratedRate ? '사용' : '사용 안 함' }}
                                                </b-form-checkbox>
                                                <div v-if="settingsData.useIntegratedRate" class="small mt-1 text-left">
                                                    <div>통합통관 환율: <b>{{ integratedRate ? integratedRate + '원' : '불러오지 못함' }}</b></div>
                                                    <div>포장검수: 200원 · 바코드: 100원 · 관부가세 ×1.1</div>
                                                </div>
                                            </b-form-group>

                                            <b-form-group label="적용환율 (CNY → KRW)" label-for="exchange-rate-input"
                                                :description="settingsData.useIntegratedRate ? '통합통관 환율 사용 중 — 묶음 수량 자동 계산에만 쓰입니다' : ''">
                                                <div class="d-flex align-items-center">
                                                    <span>x </span>
                                                    <b-form-input id="exchange-rate-input"
                                                        v-model.number="settingsData.exchangeRate" type="number"
                                                        min="150" max="350" class="ml-2"></b-form-input>
                                                </div>
                                            </b-form-group>

                                            <b-form-group label="가격 반올림 단위" label-for="round-unit-select">
                                                <b-form-select id="round-unit-select" v-model="settingsData.roundUnit"
                                                    :options="roundUnitOptions">
                                                </b-form-select>
                                            </b-form-group>

                                            <b-form-group label="시장가격(MSRP) 배수" label-for="msrp-multiplier-input"
                                                description="판매가 대비 시장가격 비율">
                                                <div class="d-flex align-items-center">
                                                    <span>x </span>
                                                    <b-form-input id="msrp-multiplier-input"
                                                        v-model="settingsData.msrpMultiplier" type="number"
                                                        min="1.0" max="2.0" step="0.1" class="ml-2"></b-form-input>
                                                </div>
                                            </b-form-group>
                                        </div>

                                        <!-- 공급 마진율 -->
                                        <b-form-group label="공급 마진율 (%)" description="공급가 = 매입가 ÷ (1 - 공급마진율/100)">
                                            <div class="d-flex align-items-center mb-2">
                                                <b-form-input v-model.number="settingsData.marginRate" type="number"
                                                    min="0" max="99" class="mr-2"
                                                    @input="updateRatioDisplay"></b-form-input>
                                                <span>%</span>
                                            </div>
                                            <input type="range" class="custom-range mt-2"
                                                v-model.number="settingsData.marginRate" min="0" max="90" step="1"
                                                @input="updateRatioDisplay">
                                        </b-form-group>

                                        <!-- 쿠팡 마진율 -->
                                        <b-form-group label="쿠팡 마진율 (%)" description="판매가 = 공급가 ÷ (1 - 쿠팡마진율/100)">
                                            <div class="d-flex align-items-center mb-2">
                                                <b-form-input v-model.number="settingsData.coupangMarginRate"
                                                    type="number" min="0" max="99" class="mr-2"
                                                    @input="updateRatioDisplay"></b-form-input>
                                                <span>%</span>
                                            </div>
                                            <input type="range" class="custom-range mt-2"
                                                v-model.number="settingsData.coupangMarginRate" min="0" max="90"
                                                step="1" @input="updateRatioDisplay">
                                        </b-form-group>
                                    </div>

                                    <!-- 최소 공급 마진 보장 설정 -->
                                    <div class="mt-4">
                                        <div class="d-flex align-items-center mb-2">
                                            <b-form-checkbox v-model="settingsData.enableMinSupplyMargin" switch class="mr-2">
                                                최소 공급 마진 보장
                                            </b-form-checkbox>
                                            <small class="text-muted">
                                                쿠팡 마진율은 고정하고 원가율을 조정하여 최소 공급 마진액을 보장합니다
                                            </small>
                                        </div>

                                        <div v-if="settingsData.enableMinSupplyMargin" class="mt-2">
                                            <b-form-group label="최소 공급 마진액 (원)" class="mb-0">
                                                <b-form-input
                                                    v-model.number="settingsData.minSupplyMarginAmount"
                                                    type="number"
                                                    min="0"
                                                    step="100"
                                                    placeholder="예: 3000">
                                                </b-form-input>
                                                <small class="text-muted">
                                                    공급가 = 원가 + 이 금액, 판매가 = 공급가 ÷ (1 - 쿠팡마진율)로 계산됩니다
                                                </small>
                                            </b-form-group>
                                        </div>
                                    </div>

                                    <!-- 번들링 설정 추가 -->
                                    <div class="mt-4">
                                        <div class="d-flex align-items-center mb-2">
                                            <b-form-checkbox switch v-model="settingsData.enableBundling" class="mr-2">
                                                번들링 활성화
                                            </b-form-checkbox>
                                            <small class="text-muted">낮은 마진 상품을 자동으로 묶어서 판매합니다</small>
                                        </div>

                                        <div v-if="settingsData.enableBundling" class="mt-3">
                                            <b-form-group label="번들링 기준" v-slot="{ ariaDescribedby }">
                                                <b-form-radio-group v-model="settingsData.bundlingType"
                                                    :options="bundlingTypeOptions"
                                                    :aria-describedby="ariaDescribedby"></b-form-radio-group>
                                            </b-form-group>

                                            <div v-if="settingsData.bundlingType === 'marginAmount'" class="mt-2">
                                                <b-form-group label="최소 공급 마진액 (원)">
                                                    <b-form-input v-model.number="settingsData.minMarginAmount"
                                                        type="number" min="1000" step="1000"></b-form-input>
                                                    <small class="form-text text-muted">이 금액보다 마진이 낮으면 2p, 4p,
                                                        6p... 단위로
                                                        번들링합니다</small>
                                                </b-form-group>
                                            </div>

                                            <div v-else class="mt-2">
                                                <b-form-group label="최소 쿠팡 마진액 (원)">
                                                    <b-form-input v-model.number="settingsData.minCoupangMarginAmount"
                                                        type="number" min="1000" step="1000"></b-form-input>
                                                    <small class="form-text text-muted">이 금액보다 마진이 낮으면 2p, 4p,
                                                        6p... 단위로
                                                        자동번들링 됩니다</small>
                                                </b-form-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 로켓 소싱 마진 기준(판 #389) — 소싱 탈락 판정(calculateMargin·대기열·등록 화면 재검사)에 쓴다 · 위 가격설정 마진율과 따로 -->
                        <div class="col-md-6">
                            <div class="card mb-3">
                                <div class="card-header bg-light">
                                    <h6 class="mb-0">로켓 소싱 마진 기준</h6>
                                </div>
                                <div class="card-body">
                                    <small class="form-text text-muted mb-2">소싱 후보를 거르는 기준입니다. 정하지 않으면 공급마진율 25% 미만 상품을 거릅니다. 위 «가격설정 방법»의 마진율과는 따로입니다.</small>
                                    <b-form-group label="거르는 기준" v-slot="{ ariaDescribedby }">
                                        <b-form-radio-group v-model="marginGate.mode" :options="marginGateModeOptions"
                                            :aria-describedby="ariaDescribedby" stacked></b-form-radio-group>
                                    </b-form-group>
                                    <b-form-group v-if="marginGate.mode !== 'amount'" label="최소 공급마진율 (%)">
                                        <b-form-input v-model.number="marginGate.minRate" type="number" min="0" max="99" step="1"></b-form-input>
                                    </b-form-group>
                                    <b-form-group v-if="marginGate.mode !== 'rate'" label="최소 공급마진액 (원)">
                                        <b-form-input v-model.number="marginGate.minAmount" type="number" min="0" step="100"></b-form-input>
                                    </b-form-group>
                                    <small class="form-text text-muted">지금 기준: {{ marginGateSummary }}</small>
                                </div>
                            </div>
                        </div>

                        <!-- 이미지 작업 설정 영역 -->
                        <div class="col-md-6">
                            <div class="card mb-3">
                                <div class="card-header bg-light">
                                    <h6 class="mb-0">이미지 작업 설정</h6>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <!-- 상단 이미지 설정 -->
                                            <div class="form-group">
                                                <div class="d-flex align-items-center mb-2">
                                                    <b-form-checkbox switch
                                                        v-model="settingsData.imageSettings.useTopImage" class="mr-2">
                                                        상단 이미지 사용
                                                    </b-form-checkbox>
                                                    <small class="text-muted">브랜드 이미지, 이벤트 이미지 등</small>
                                                </div>
                                                <div v-if="settingsData.imageSettings.useTopImage" class="mt-2">
                                                    <!-- 이미지가 없을 때 보여줄 드롭 영역 -->
                                                    <div v-if="!settingsData.imageSettings.topImageUrl && !topImageFile"
                                                        class="image-drop-area" @dragover.prevent
                                                        @drop.prevent="handleTopImageDrop" @click="triggerTopImageInput"
                                                        @paste="handleTopImagePaste">
                                                        <div class="text-center">
                                                            <i class="las la-plus-circle" style="font-size: 24px;"></i>
                                                            <p class="mb-0">이미지를 여기에 끌어다 놓거나, 클릭하여 선택하세요</p>
                                                            <p class="text-muted small">또는 Ctrl+V로 클립보드 이미지를
                                                                붙여넣으세요</p>
                                                        </div>
                                                    </div>

                                                    <!-- 이미지가 있을 때 보여줄 미리보기 -->
                                                    <!-- 예전엔 미리보기에 클릭 핸들러가 없고 삭제 버튼도 hover 해야 나타나서,
                                                         저장한 뒤에는 다른 이미지로 바꿀 방법이 사실상 없었다(2026-09-04 문의) -->
                                                    <div v-else class="position-relative d-inline-block">
                                                        <img :src="topImagePreviewUrl || settingsData.imageSettings.topImageUrl"
                                                            class="img-thumbnail image-replaceable" style="max-height: 150px;"
                                                            title="클릭하면 다른 이미지로 바꿉니다"
                                                            @click="triggerTopImageInput">
                                                        <button
                                                            class="btn btn-sm btn-danger position-absolute delete-image-btn"
                                                            title="이미지 삭제"
                                                            @click.prevent="removeTopImage">
                                                            <i class="las la-trash"></i>
                                                        </button>
                                                        <div class="mt-1">
                                                            <b-button size="sm" variant="outline-primary" class="mr-1"
                                                                @click.prevent="triggerTopImageInput">이미지 변경</b-button>
                                                            <b-button size="sm" variant="outline-danger"
                                                                @click.prevent="removeTopImage">삭제</b-button>
                                                        </div>
                                                    </div>

                                                    <!-- 숨겨진 파일 입력 -->
                                                    <input ref="topImageInput" type="file" class="d-none"
                                                        accept="image/*" @change="handleTopImageSelect">
                                                </div>
                                            </div>

                                            <!-- 하단 이미지 설정 -->
                                            <div class="form-group">
                                                <div class="d-flex align-items-center mb-2">
                                                    <b-form-checkbox switch
                                                        v-model="settingsData.imageSettings.useBottomImage"
                                                        class="mr-2">
                                                        하단 이미지 사용
                                                    </b-form-checkbox>
                                                    <small class="text-muted">배송, 보상, 반품 유의사항 등</small>
                                                </div>
                                                <div v-if="settingsData.imageSettings.useBottomImage" class="mt-2">
                                                    <!-- 이미지가 없을 때 보여줄 드롭 영역 -->
                                                    <div v-if="!settingsData.imageSettings.bottomImageUrl && !bottomImageFile"
                                                        class="image-drop-area" @dragover.prevent
                                                        @drop.prevent="handleBottomImageDrop"
                                                        @click="triggerBottomImageInput"
                                                        @paste="handleBottomImagePaste">
                                                        <div class="text-center">
                                                            <i class="las la-plus-circle" style="font-size: 24px;"></i>
                                                            <p class="mb-0">이미지를 여기에 끌어다 놓거나, 클릭하여 선택하세요</p>
                                                            <p class="text-muted small">또는 Ctrl+V로 클립보드 이미지를
                                                                붙여넣으세요</p>
                                                        </div>
                                                    </div>

                                                    <!-- 이미지가 있을 때 보여줄 미리보기 (상단과 동일) -->
                                                    <div v-else class="position-relative d-inline-block">
                                                        <img :src="bottomImagePreviewUrl || settingsData.imageSettings.bottomImageUrl"
                                                            class="img-thumbnail image-replaceable" style="max-height: 150px;"
                                                            title="클릭하면 다른 이미지로 바꿉니다"
                                                            @click="triggerBottomImageInput">
                                                        <button
                                                            class="btn btn-sm btn-danger position-absolute delete-image-btn"
                                                            title="이미지 삭제"
                                                            @click.prevent="removeBottomImage">
                                                            <i class="las la-trash"></i>
                                                        </button>
                                                        <div class="mt-1">
                                                            <b-button size="sm" variant="outline-primary" class="mr-1"
                                                                @click.prevent="triggerBottomImageInput">이미지 변경</b-button>
                                                            <b-button size="sm" variant="outline-danger"
                                                                @click.prevent="removeBottomImage">삭제</b-button>
                                                        </div>
                                                    </div>

                                                    <!-- 숨겨진 파일 입력 -->
                                                    <input ref="bottomImageInput" type="file" class="d-none"
                                                        accept="image/*" @change="handleBottomImageSelect">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <!-- 이미지 번역 설정 -->
                                            <div class="form-group">
                                                <div class="d-flex align-items-center mb-2">
                                                    <b-form-checkbox switch
                                                        v-model="settingsData.imageSettings.translateImages"
                                                        class="mr-2">
                                                        이미지 번역
                                                    </b-form-checkbox>
                                                    <small class="text-muted">중국어/영어 포함 이미지를 한글로 자동 번역</small>
                                                </div>
                                            </div>

                                            <!-- 이미지 번역 프롬프트 설정 -->
                                            <div class="form-group" v-if="settingsData.imageSettings.translateImages">
                                                <label for="translation-prompt-style">이미지 번역 프롬프트 설정</label>
                                                <b-form-textarea
                                                    id="translation-prompt-style"
                                                    v-model="settingsData.imageSettings.translationPromptStyle"
                                                    rows="4"
                                                    placeholder="카피라이팅 스타일 가이드를 입력하세요..."
                                                    trim>
                                                </b-form-textarea>
                                                <small class="form-text text-muted">
                                                    AI가 이미지 텍스트를 번역할 때 사용할 카피라이팅 스타일 가이드를 설정하세요.
                                                    각 항목을 '-'로 시작하여 줄바꿈으로 구분해주세요.
                                                </small>
                                            </div>

                                            <!-- 카피라이트 설정 -->
                                            <div class="form-group mt-3"
                                                v-if="settingsData.imageSettings.translateImages">
                                                <div class="d-flex align-items-center mb-2">
                                                    <b-form-checkbox switch
                                                        v-model="settingsData.imageSettings.addCopyright" class="mr-2">
                                                        카피라이트 추가
                                                    </b-form-checkbox>
                                                    <small class="text-muted">번역된 이미지에 자동으로 AI카피라이트 추가</small>
                                                </div>
                                            </div>

                                            <!-- 누끼이미지 자동적용 설정 -->
                                            <div class="form-group mt-3">
                                                <div class="d-flex align-items-center mb-2">
                                                    <b-form-checkbox switch
                                                        v-model="settingsData.imageSettings.autoApplyMatting" class="mr-2">
                                                        누끼이미지 자동적용
                                                    </b-form-checkbox>
                                                    <small class="text-muted">대표 이미지 처리 시 AI로 배경 제거 및 텍스트 제거 자동 적용</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- AI 설정 영역 -->
                        <div class="col-md-6">
                            <div class="card mb-3">
                                <div class="card-header bg-light">
                                    <h6 class="mb-0">AI 설정</h6>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <!-- Gemini API 서버 중앙화 안내 -->
                                            <div class="alert alert-success mb-3 p-3">
                                                <i class="las la-check-circle mr-1"></i>
                                                <strong>AI 서버 자동 처리</strong>
                                                <p class="ml-2 mb-0 mt-1 small">
                                                    모든 AI 기능(이미지 번역, SEO 최적화, 등록정보 자동생성 등)이 서버에서 처리되므로,
                                                    별도의 API Key 발급이나 구글 유료결제가 불필요합니다.<br>
                                                    기존에 API Key 유료결제를 설정하셨다면 해지하셔도 됩니다.
                                                </p>
                                            </div>

                                            <!-- 비노출속성 자동 생성 설정 -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input"
                                                           id="enable-unexposed-attributes"
                                                           v-model="enableUnexposedAttributes">
                                                    <label class="custom-control-label font-weight-bold"
                                                           for="enable-unexposed-attributes">
                                                        비노출속성 자동 생성
                                                    </label>
                                                </div>
                                                <div class="alert alert-warning mt-2 p-2 small">
                                                    <i class="las la-exclamation-triangle mr-1"></i>
                                                    비활성화하면 속도가 빨라집니다. 비노출속성이 필요하지 않은 경우 비활성화를 권장합니다.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 저장 버튼 -->
                    <div class="d-flex justify-content-end mt-4">
                        <b-button variant="primary" @click="saveSettings">
                            <i class="las la-save mr-1"></i> 설정 저장
                        </b-button>
                    </div>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import pricingPolicy from '@/services/works/pricingPolicy';

// 마진 기준 화면 칸의 처음 값 = 서버 기본(공급마진율 25%) · 이 꼴 그대로면 저장하지 않는다
const DEFAULT_MARGIN_GATE_FORM = Object.freeze({ mode: 'rate', minRate: 25, minAmount: null });

export default {
    name: "RocketSettingsPanel",
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // 판 #389: Settings 맨 위 칸 rocketMarginGate — defaultSettings 밖이라 settingsData 와 따로 든다(서버 저장도 맨 위 칸)
            marginGate: { ...DEFAULT_MARGIN_GATE_FORM },
            marginGateModeOptions: [
                { text: '마진율만', value: 'rate' },
                { text: '마진액만', value: 'amount' },
                { text: '둘 다 넘어야 통과', value: 'both' },
                { text: '둘 중 하나만 넘어도 통과', value: 'either' },
            ],
            settingsData: {
                brand: '',
                manufacturer: '',
                importer: '',
                transactionType: '기타 도소매업자',
                importStatus: '수입상품',
                asInfo: '',

                exchangeRate: 350,
                useIntegratedRate: false,   // 쿠패스 통합통관 환율로 매입가 계산 (pricingPolicy.purchaseCost)
                marginRate: 40,
                coupangMarginRate: 40,
                roundUnit: 100,
                msrpMultiplier: 1.3,
                enableMinSupplyMargin: false,
                minSupplyMarginAmount: 3000,
                enableBundling: false,
                bundlingType: 'marginAmount',
                minMarginAmount: 3000,
                minCoupangMarginAmount: 3000,
                // 한글표시사항 관련 추가 필드
                washingMethod: '',         // 세탁방법
                handlingPrecautions: '',    // 취급시 주의사항
                manufactureDate: '',        // 제조연월
                // 물류 정보 관련 추가 필드
                totalSKUsInBox: 1,          // 박스 내 SKU 수량
                daysToExpiration: 0,        // 유통기한
                specialHandlingReason: '해당사항없음', // 취급주의 사유
                enableUnexposedAttributes: false,  // 비노출속성 자동 생성 (기본값: false)
                imageSettings: {
                    useTopImage: false,
                    topImageUrl: '',
                    useBottomImage: false,
                    bottomImageUrl: '',
                    translateImages: true,
                    addCopyright: false,
                    translationPromptStyle: `- 온라인 쇼핑객들에게 인기 있는 현대적이고 트렌디한 한국어 표현을 사용하세요 (예: 득템, 인생템, 꿀템)
- 번역에 이모티콘이나 이모지를 사용하지 마세요
- 제품의 시각적 스타일과 타겟 고객에 맞는 마케팅 카피를 작성하세요
- 직역보다는 감정적 연결에 집중하세요
- 제품 사양의 경우 핵심 요소만 간단히 표현하세요
- 가능한 한 짧은 단어와 줄임말을 사용하세요`,
                    autoApplyMatting: false  // 누끼이미지 자동적용 기본값: OFF
                }
            },
            integratedRate: pricingPolicy.getIntegratedRate(),
            geminiAPIKey: '',
            geminiModel: 'gemini-2.5-flash-lite',
            geminiModelOptions: [
                { value: 'gemini-2.5-flash-lite', text: 'Gemini 2.5 Flash Lite (최신, 빠르고 가벼움, 기본값)' },
                { value: 'gemini-2.5-flash', text: 'Gemini 2.5 Flash (최신, 안정성, 무료25만토큰)' },
                { value: 'gemini-3.6-flash', text: 'Gemini 3.6 Flash (안정성)' },
                { value: 'gemini-3.5-flash-lite', text: 'Gemini 3.5 Flash Lite (빠르고 가벼움)' }
            ],
            transactionTypeOptions: [
                { value: '제조사', text: '제조사' },
                { value: '공식총판사', text: '공식총판사' },
                { value: '공식대리점', text: '공식대리점' },
                { value: '기타 도소매업자', text: '기타 도소매업자' }
            ],
            importStatusOptions: [
                { value: '수입대상아님', text: '수입대상아님' },
                { value: '수입상품', text: '수입상품' },
                { value: '병행수입상품', text: '병행수입상품' }
            ],
            roundUnitOptions: [
                { value: 1, text: '1원 단위' },
                { value: 10, text: '10원 단위' },
                { value: 100, text: '100원 단위' },
                { value: 1000, text: '1,000원 단위' }
            ],
            bundlingTypeOptions: [
                { text: '최소 공급 마진액 기준', value: 'marginAmount' },
                { text: '최소 쿠팡 마진액 기준', value: 'coupangMarginAmount' }
            ],
            topImageFile: null,
            bottomImageFile: null,
            topImagePreviewUrl: null,
            bottomImagePreviewUrl: null,
            imagesToUpload: {
                top: null,
                bottom: null
            },
            imageUploading: false
        };
    },
    computed: {
        marginGateSummary() {
            try {
                return pricingPolicy.marginGateText(pricingPolicy.marginGate(this.marginGatePayload()));
            } catch (e) {
                return '값을 확인하세요 — ' + e.message;
            }
        },
        ...mapState({
            storeSettings: state => state.settings[0]?.defaultSettings || {}
        }),

        showSettings: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },

        costRatio() {
            const marginRate = this.settingsData.marginRate;
            const coupangRate = this.settingsData.coupangMarginRate;
            return Math.max(1, 100 - marginRate - coupangRate);
        },

        marginRatioPercent() {
            return this.settingsData.marginRate;
        },

        coupangRatioPercent() {
            return this.settingsData.coupangMarginRate;
        },

        // 비노출속성 자동 생성 설정
        enableUnexposedAttributes: {
            get() {
                const value = this.settingsData.enableUnexposedAttributes;
                console.log('🔍 [설정 GET] enableUnexposedAttributes 조회:', {
                    원본값: this.settingsData.enableUnexposedAttributes,
                    반환값: value
                });
                return value;
            },
            set(value) {
                console.log('🔍 [설정 SET] enableUnexposedAttributes 변경:', {
                    이전값: this.settingsData.enableUnexposedAttributes,
                    새값: value
                });
                this.settingsData.enableUnexposedAttributes = value;
                console.log('🔍 [설정 SET] 변경 후 settingsData.enableUnexposedAttributes:', this.settingsData.enableUnexposedAttributes);
                console.log('🔍 [설정 SET] 변경 후 전체 settingsData:', this.settingsData);
            }
        }
    },
    watch: {
        // 대기열(탈환의깃발)이 기본세팅 스위치를 켜면 store 만 바뀐다. 패널은 created 때 한 번 복사하므로
        // 따라가지 않으면 패널이 꺼진 채로 보이고, 그대로 저장하면 스위치가 다시 꺼진다.
        'storeSettings.useIntegratedRate'(on) {
            this.settingsData.useIntegratedRate = !!on;
            if (on) this.loadIntegratedRate();
        }
    },
    created() {
        this.initializeSettings();
        if (this.settingsData.useIntegratedRate) this.loadIntegratedRate();
    },
    methods: {
        // 서버의 통합통관 환율을 받아 표시하고 가격 계산에도 넣는다
        async loadIntegratedRate() {
            try {
                const res = await axios.post('/api/getExchangeRate', {});
                const d = res.data && res.data.data;
                const rate = d && d.integratedRateFound ? Number(d.integratedRate) : null;
                if (!rate) console.error('[RocketSettingsPanel] 통합통관 환율이 서버에 없습니다:', res.data);
                pricingPolicy.setIntegratedRate(rate);
            } catch (e) {
                console.error('[RocketSettingsPanel] 통합통관 환율 조회 실패:', e);
                pricingPolicy.setIntegratedRate(null);
            }
            this.integratedRate = pricingPolicy.getIntegratedRate();
        },

        onIntegratedRateToggle(on) {
            if (on) this.loadIntegratedRate();
        },

        // 화면 칸 → 저장 꼴(쓰지 않는 칸은 null)
        marginGatePayload() {
            const g = this.marginGate;
            return { mode: g.mode, minRate: g.mode === 'amount' ? null : g.minRate, minAmount: g.mode === 'rate' ? null : g.minAmount };
        },

        // 저장된 기준(없으면 기본 꼴)과 다르면 참 — 기본 그대로면 칸을 만들지 않는다(칸 없음 = 기본 25%)
        marginGateChanged() {
            const stored = this.$store.state.settings?.[0]?.rocketMarginGate;
            return JSON.stringify(this.marginGatePayload()) !== JSON.stringify(stored || DEFAULT_MARGIN_GATE_FORM);
        },

        initializeSettings() {
            const storedGate = this.$store.state.settings?.[0]?.rocketMarginGate;
            this.marginGate = storedGate ? { ...DEFAULT_MARGIN_GATE_FORM, ...storedGate } : { ...DEFAULT_MARGIN_GATE_FORM };
            // 스토어에서 설정 로드
            if (this.storeSettings && Object.keys(this.storeSettings).length > 0) {
                // 깊은 복사를 통해 기존 구조 유지하면서 storeSettings의 값으로 초기화
                this.settingsData = this.deepClone(this.storeSettings);
                this.settingsData.msrpMultiplier = this.storeSettings.msrpMultiplier || 1.3;

                // 새로운 설정 필드에 대한 기본값 처리 (기존 사용자 호환성)
                console.log('🔍 [초기화] enableUnexposedAttributes 초기값 확인:', this.settingsData.enableUnexposedAttributes);
                if (this.settingsData.enableUnexposedAttributes === undefined) {
                    this.settingsData.enableUnexposedAttributes = true; // 기본값 true
                    console.log('🔍 [초기화] 기존 사용자를 위해 enableUnexposedAttributes 기본값 설정: true');
                } else {
                    console.log('🔍 [초기화] enableUnexposedAttributes 기존값 유지:', this.settingsData.enableUnexposedAttributes);
                }

                // imageSettings 기본값 처리
                if (!this.settingsData.imageSettings) {
                    this.settingsData.imageSettings = {};
                }
                if (this.settingsData.imageSettings.autoApplyMatting === undefined) {
                    this.settingsData.imageSettings.autoApplyMatting = false; // 기본값 false
                    console.log('🔍 [초기화] autoApplyMatting 기본값 설정: false');
                }
            }

            // API 키 및 모델 로드
            if (this.$store.state.settings[0] && this.$store.state.settings[0].geminiAPIKey) {
                this.geminiAPIKey = this.$store.state.settings[0].geminiAPIKey;
            }
            if (this.$store.state.settings[0] && this.$store.state.settings[0].geminiModel) {
                this.geminiModel = this.$store.state.settings[0].geminiModel;
            }

            console.log(this.settingsData)
        },

        updateRatioDisplay() {
            // 마진율 합이 95%를 초과하지 않도록 제한
            const totalMargin = this.settingsData.marginRate + this.settingsData.coupangMarginRate;
            if (totalMargin > 99) {
                // 비율 유지하면서 조정
                const scale = 99 / totalMargin;
                this.settingsData.marginRate = Math.round(this.settingsData.marginRate * scale);
                this.settingsData.coupangMarginRate = Math.round(this.settingsData.coupangMarginRate * scale);
            }
        },
        deepClone(obj) {
			if (obj === null || typeof obj !== "object") {
				return obj
			}

			const result = Array.isArray(obj) ? [] : {}

			for (let key of Object.keys(obj)) {
				result[key] = this.deepClone(obj[key])
			}

			return result
		},

        openGeminiHelp() {
            window.open('https://aistudio.google.com/app/apikey', '_blank');
        },

        async saveSettings() {
            // 원본 설정과 현재 설정을 비교하기 위해 깊은 복사 사용
            const originalSettings = JSON.parse(JSON.stringify(this.storeSettings || {}));
            const currentSettings = JSON.parse(JSON.stringify(this.settingsData));

            // 이미지 업로드가 없고, 설정 변경이 없는 경우 저장 없이 collapse 닫기
            const gateChanged = this.marginGateChanged();
            if (gateChanged) {
                try {
                    pricingPolicy.marginGate(this.marginGatePayload());
                } catch (e) {
                    this.$bvToast.toast(e.message, { title: '마진 기준 확인', variant: 'danger', solid: true, toaster: 'b-toaster-bottom-right' });
                    return;
                }
            }
            if (!this.imagesToUpload.top && !this.imagesToUpload.bottom && !gateChanged &&
                this.isSettingsEqual(originalSettings, currentSettings)) {
                console.log('설정 변경사항 없음, collapse 닫기');
                console.log('🔍 [변경사항 없음] 원본 설정:', originalSettings);
                console.log('🔍 [변경사항 없음] 현재 설정:', currentSettings);
                console.log('🔍 [변경사항 없음] 원본 enableUnexposedAttributes:', originalSettings.enableUnexposedAttributes);
                console.log('🔍 [변경사항 없음] 현재 enableUnexposedAttributes:', currentSettings.enableUnexposedAttributes);
                console.log('🔍 [변경사항 없음] 현재 store enableUnexposedAttributes:', this.$store.state.settings[0]?.enableUnexposedAttributes);
                this.showSettings = false;
                return;
            }

            this.imageUploading = true;
            try {
                console.log('설정 저장 시작, 이미지 업로드 확인...');

                // 이미지 업로드 처리
                if (this.imagesToUpload.top) {
                    console.log('상단 이미지 업로드 시작');
                    const topImageUrl = await this.uploadImageToS3(
                        this.imagesToUpload.top.data,
                        this.imagesToUpload.top.filename,
                        'top'
                    );
                    if (topImageUrl) {
                        console.log('상단 이미지 업로드 성공:', topImageUrl);
                        this.settingsData.imageSettings.topImageUrl = topImageUrl;
                    } else {
                        console.error('상단 이미지 업로드 실패: URL이 반환되지 않음');
                    }
                }

                if (this.imagesToUpload.bottom) {
                    console.log('하단 이미지 업로드 시작');
                    const bottomImageUrl = await this.uploadImageToS3(
                        this.imagesToUpload.bottom.data,
                        this.imagesToUpload.bottom.filename,
                        'bottom'
                    );
                    if (bottomImageUrl) {
                        console.log('하단 이미지 업로드 성공:', bottomImageUrl);
                        this.settingsData.imageSettings.bottomImageUrl = bottomImageUrl;
                    } else {
                        console.error('하단 이미지 업로드 실패: URL이 반환되지 않음');
                    }
                }

                console.log('설정 저장 API 호출...');
                console.log('🔍 [설정 저장] 전송할 데이터:', this.settingsData);
                console.log('🔍 [설정 저장] enableUnexposedAttributes 값:', this.settingsData.enableUnexposedAttributes);

                // 서버에 설정 저장
                const result = await axios.post('/api/savesetting', {
                    defaultSettings: this.settingsData,
                    geminiAPIKey: this.geminiAPIKey,
                    geminiModel: this.geminiModel,
                    ...(gateChanged ? { rocketMarginGate: this.marginGatePayload() } : {})
                });

                console.log('설정 저장 응답:', result.data);

                if (result.data.success) {
                    this.$store.commit('settingsupdate', [result.data.data]);

                    // 저장 후 Vuex store 상태 확인
                    console.log('🔍 [저장 후] Vuex store 상태 확인:');
                    console.log('- store.state.settings[0].enableUnexposedAttributes:', this.$store.state.settings[0]?.enableUnexposedAttributes);

                    // 이미지 객체 초기화
                    this.topImageFile = null;
                    this.bottomImageFile = null;
                    this.topImagePreviewUrl = null;
                    this.bottomImagePreviewUrl = null;
                    this.imagesToUpload = {
                        top: null,
                        bottom: null
                    };

                    this.$bvToast.toast('설정이 저장되었습니다.', {
                        title: '저장 완료',
                        variant: 'success',
                        solid: true,
                        toaster: 'b-toaster-bottom-right'
                    });

                    // 저장 후 collapse 닫기
                    this.showSettings = false;

                    // 부모 컴포넌트에 저장 이벤트 전달
                    this.$emit('settings-saved', this.settingsData);
                } else {
                    this.$bvToast.toast('저장 실패 (510)', {
                        title: '저장 오류',
                        variant: 'danger',
                        solid: true,
                        toaster: 'b-toaster-bottom-right'
                    });
                    console.error('설정 저장 실패:', result.data);
                }
            } catch (e) {
                this.$bvToast.toast('저장 실패 (514)', {
                    title: '저장 오류',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
                console.error('설정 저장 중 예외 발생:', e);
            } finally {
                this.imageUploading = false;
            }
        },

        // 두 설정 객체가 동일한지 비교하는 헬퍼 메서드
        isSettingsEqual(obj1, obj2) {
            console.log('🔍 [설정 비교] isSettingsEqual 시작');
            console.log('🔍 [설정 비교] obj1 (원본):', obj1);
            console.log('🔍 [설정 비교] obj2 (현재):', obj2);
            console.log('🔍 [설정 비교] obj1.enableUnexposedAttributes:', obj1?.enableUnexposedAttributes);
            console.log('🔍 [설정 비교] obj2.enableUnexposedAttributes:', obj2?.enableUnexposedAttributes);

            // 이미지 URL과 Gemini API Key를 비교에서 제외하기 위해 깊은 복사본 생성
            if (!obj1 || !obj2) return false;

            // 객체 복사
            const obj1Copy = JSON.parse(JSON.stringify(obj1));
            const obj2Copy = JSON.parse(JSON.stringify(obj2));

            // 이미지 URL 제외
            if (obj1Copy.imageSettings) {
                delete obj1Copy.imageSettings.topImageUrl;
                delete obj1Copy.imageSettings.bottomImageUrl;
            }

            if (obj2Copy.imageSettings) {
                delete obj2Copy.imageSettings.topImageUrl;
                delete obj2Copy.imageSettings.bottomImageUrl;
            }

            // Gemini API Key와 모델은 별도로 비교
            const currentGeminiKey = this.geminiAPIKey || '';
            const originalGeminiKey = this.$store.state.settings[0]?.geminiAPIKey || '';
            const currentGeminiModel = this.geminiModel || 'gemini-2.5-flash-lite';
            const originalGeminiModel = this.$store.state.settings[0]?.geminiModel || 'gemini-2.5-flash-lite';

            // 객체 비교
            const settingsEqual = JSON.stringify(obj1Copy) === JSON.stringify(obj2Copy);
            const geminiKeyEqual = currentGeminiKey === originalGeminiKey;
            const geminiModelEqual = currentGeminiModel === originalGeminiModel;

            console.log('🔍 [설정 비교] 비교 결과:');
            console.log('- settingsEqual:', settingsEqual);
            console.log('- geminiKeyEqual:', geminiKeyEqual);
            console.log('- geminiModelEqual:', geminiModelEqual);
            console.log('- obj1Copy JSON:', JSON.stringify(obj1Copy));
            console.log('- obj2Copy JSON:', JSON.stringify(obj2Copy));
            console.log('- 최종 결과:', settingsEqual && geminiKeyEqual && geminiModelEqual);

            // 설정, Gemini API Key, Gemini 모델 모두 동일해야 true 반환
            return settingsEqual && geminiKeyEqual && geminiModelEqual;
        },

        // 이미지 업로드 관련 메서드
        triggerTopImageInput() {
            this.$refs.topImageInput.click();
        },

        handleTopImageSelect(event) {
            const file = event.target.files[0];
            if (file) {
                this.processTopImage(file);
            }
            // 같은 파일을 다시 고르면 change 가 안 뜬다. 교체용으로 쓰면 바로 밟는다
            event.target.value = '';
        },

        handleTopImageDrop(event) {
            const file = event.dataTransfer.files[0];
            if (file && file.type.startsWith('image/')) {
                this.processTopImage(file);
            }
        },

        handleTopImagePaste(event) {
            const items = (event.clipboardData || event.originalEvent.clipboardData).items;
            for (const item of items) {
                if (item.type.indexOf('image') === 0) {
                    const file = item.getAsFile();
                    this.processTopImage(file);
                    break;
                }
            }
        },

        async processTopImage(file) {
            if (!file) {
                console.error('processTopImage: 파일이 없습니다.');
                return;
            }

            try {
                // 파일 확장자 추출 및 검증
                const fileExt = file.name.split('.').pop().toLowerCase() || 'png';
                if (!['jpg', 'jpeg', 'png', 'gif'].includes(fileExt)) {
                    this.$bvToast.toast('지원되는 이미지 형식이 아닙니다.', {
                        title: '업로드 오류',
                        variant: 'warning',
                        solid: true,
                        toaster: 'b-toaster-bottom-right'
                    });
                    return;
                }

                // 파일 미리보기 설정
                this.topImageFile = file;
                this.topImagePreviewUrl = URL.createObjectURL(file);

                // 회사 ID 확인
                const companyId = this.$store.state.user.companyid || 'unknown';
                console.log('이미지 처리 - 회사 ID:', companyId);

                // 파일을 Base64로 변환
                const base64Data = await this.fileToBase64(file);
                console.log('이미지 Base64 변환 완료, 길이:', base64Data ? base64Data.length : 0);

                // 업로드 정보 저장
                this.imagesToUpload.top = {
                    file: file,
                    data: base64Data,
                    filename: `${companyId}_topimage.${fileExt}`,
                    contentType: file.type,
                    type: 'top'
                };

                console.log('상단 이미지 처리 완료:', {
                    filename: this.imagesToUpload.top.filename,
                    type: this.imagesToUpload.top.type,
                    contentType: this.imagesToUpload.top.contentType
                });
            } catch (error) {
                console.error('이미지 처리 중 오류:', error);
                this.$bvToast.toast('이미지 처리 중 오류가 발생했습니다.', {
                    title: '처리 오류',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
            }

            this.$bvToast.toast('이미지가 선택되었습니다. 설정 저장 시 업로드됩니다.', {
                title: '이미지 선택',
                variant: 'info',
                solid: true,
                toaster: 'b-toaster-bottom-right'
            });
        },

        removeTopImage() {
            this.topImageFile = null;
            this.topImagePreviewUrl = null;

            if (this.settingsData.imageSettings.topImageUrl) {
                // 이미 저장된 이미지가 있으면 DB에서도 삭제 표시
                this.settingsData.imageSettings.topImageUrl = '';
                this.imagesToUpload.top = null;

                this.$bvToast.toast('이미지가 삭제되었습니다. 설정 저장 시 반영됩니다.', {
                    title: '이미지 삭제',
                    variant: 'info',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
            }
        },

        // 하단 이미지 관련 메서드
        triggerBottomImageInput() {
            this.$refs.bottomImageInput.click();
        },

        handleBottomImageSelect(event) {
            const file = event.target.files[0];
            if (file) {
                this.processBottomImage(file);
            }
            // 같은 파일을 다시 고르면 change 가 안 뜬다. 교체용으로 쓰면 바로 밟는다
            event.target.value = '';
        },

        handleBottomImageDrop(event) {
            const file = event.dataTransfer.files[0];
            if (file && file.type.startsWith('image/')) {
                this.processBottomImage(file);
            }
        },

        handleBottomImagePaste(event) {
            const items = (event.clipboardData || event.originalEvent.clipboardData).items;
            for (const item of items) {
                if (item.type.indexOf('image') === 0) {
                    const file = item.getAsFile();
                    this.processBottomImage(file);
                    break;
                }
            }
        },

        async processBottomImage(file) {
            if (!file) {
                console.error('processBottomImage: 파일이 없습니다.');
                return;
            }

            try {
                // 파일 확장자 추출 및 검증
                const fileExt = file.name.split('.').pop().toLowerCase() || 'png';
                if (!['jpg', 'jpeg', 'png', 'gif'].includes(fileExt)) {
                    this.$bvToast.toast('지원되는 이미지 형식이 아닙니다.', {
                        title: '업로드 오류',
                        variant: 'warning',
                        solid: true,
                        toaster: 'b-toaster-bottom-right'
                    });
                    return;
                }

                // 파일 미리보기 설정
                this.bottomImageFile = file;
                this.bottomImagePreviewUrl = URL.createObjectURL(file);

                // 회사 ID 확인
                const companyId = this.$store.state.user.companyid || 'unknown';
                console.log('이미지 처리 - 회사 ID:', companyId);

                // 파일을 Base64로 변환
                const base64Data = await this.fileToBase64(file);
                console.log('이미지 Base64 변환 완료, 길이:', base64Data ? base64Data.length : 0);

                // 업로드 정보 저장
                this.imagesToUpload.bottom = {
                    file: file,
                    data: base64Data,
                    filename: `${companyId}_bottomimage.${fileExt}`,
                    contentType: file.type,
                    type: 'bottom'
                };

                console.log('하단 이미지 처리 완료:', {
                    filename: this.imagesToUpload.bottom.filename,
                    type: this.imagesToUpload.bottom.type,
                    contentType: this.imagesToUpload.bottom.contentType
                });
            } catch (error) {
                console.error('이미지 처리 중 오류:', error);
                this.$bvToast.toast('이미지 처리 중 오류가 발생했습니다.', {
                    title: '처리 오류',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
            }

            this.$bvToast.toast('이미지가 선택되었습니다. 설정 저장 시 업로드됩니다.', {
                title: '이미지 선택',
                variant: 'info',
                solid: true,
                toaster: 'b-toaster-bottom-right'
            });
        },

        removeBottomImage() {
            this.bottomImageFile = null;
            this.bottomImagePreviewUrl = null;

            if (this.settingsData.imageSettings.bottomImageUrl) {
                // 이미 저장된 이미지가 있으면 DB에서도 삭제 표시
                this.settingsData.imageSettings.bottomImageUrl = '';
                this.imagesToUpload.bottom = null;

                this.$bvToast.toast('이미지가 삭제되었습니다. 설정 저장 시 반영됩니다.', {
                    title: '이미지 삭제',
                    variant: 'info',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
            }
        },

        // 유틸리티 메서드
        fileToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = (e) => reject(e);
                reader.readAsDataURL(file);
            });
        },

        async uploadImageToS3(imageData, filename, type) {
            try {
                // 파라미터 유효성 검사 추가
                if (!imageData) {
                    console.error('S3 업로드 오류: 이미지 데이터가 없습니다.');
                    return null;
                }

                // 디버깅 로그 추가
                console.log('S3 업로드 요청 파라미터:', {
                    imageDataExists: !!imageData,
                    filename: filename || '(없음)',
                    type: type || '(없음)'
                });

                // Vuex 액션 사용
                const result = await this.$store.dispatch('uploadImageToS3', {
                    imageData,
                    filename,
                    type
                });

                // 응답 구조 상세 로깅
                console.log('S3 업로드 응답:', result);

                if (result && result.imageUrl) {
                    console.log(`S3 업로드 성공: ${result.imageUrl}`);
                    return result.imageUrl;
                } else if (result && typeof result === 'string') {
                    // 문자열로 URL이 반환된 경우 (이전 버전 호환)
                    console.log(`S3 업로드 성공 (문자열 URL): ${result}`);
                    return result;
                } else {
                    console.error('S3 업로드 실패:', result?.message || '알 수 없는 오류');
                    return null;
                }
            } catch (error) {
                console.error('S3 업로드 예외:', error);
                return null;
            }
        }
    }
};
</script>

<style scoped>
.image-drop-area {
    border: 2px dashed #ccc;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    background-color: #f8f9fa;
    border-radius: 5px;
    transition: all 0.3s;
}

.image-drop-area:hover {
    background-color: #e9ecef;
    border-color: #6c757d;
}

.delete-image-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    /* 예전엔 display:none 이라 이미지에 마우스를 올려야만 보였다.
       그래서 저장한 뒤 이미지를 바꾸려는 사람이 삭제 버튼을 찾지 못했다 */
    opacity: 0.85;
}

.position-relative:hover .delete-image-btn {
    opacity: 1;
}

/* 미리보기를 눌러도 파일 선택창이 뜬다 */
.image-replaceable {
    cursor: pointer;
}

.image-replaceable:hover {
    outline: 2px solid #0d6efd;
}
</style>